<template>
	<div id="app" class="relative" :class="{ 'opacity-0': !ready, 'faa-fade faa-fade-in': ready }">
		<TheLoader v-if="showMap" />
		<TheMap v-if="showMap" />
		<transition name="faa-fade">
			<router-view/>
		</transition>
		<TheUserUI/>
		<TheHomeButton/>
		<TheBreadcrumb />
		<ThePrivacyPolicy/>
		<TheRestoreBanner/>
	</div>
</template>

<script>
	import TheMap from '@/components/map/TheMap';
	import TheUserUI from '@/components/ui/TheUserUI';
	import TheLoader from '@/components/ui/TheLoader';
	import TheHomeButton from '@/components/ui/TheHomeButton';
	import TheBreadcrumb from '@/components/ui/TheBreadcrumb';
	import ThePrivacyPolicy from '@/components/ui/ThePrivacyPolicy';
	import TheRestoreBanner from '@/components/ui/TheRestoreBanner';

	export default {
		name: "App",
		components: {
			TheMap,
			TheUserUI,
			TheLoader,
			TheHomeButton,
			TheBreadcrumb,
			ThePrivacyPolicy,
			TheRestoreBanner,
		},
		data () {
			return {
				ready: false
			};
		},
		computed: {
			showMap() {
				return (this.$route.meta && this.$route.meta.showMap);
			},
		},
		mounted() {
			window.addEventListener('resize', this.isResizing)
			
			this.isResizing()
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.isResizing)
		},
		methods: {
			isResizing() {
				this.ready = false;
				
				// Debounce resize events
				if (this.resizeTimeout) {
					clearTimeout(this.resizeTimeout)
				}

				this.resizeTimeout = setTimeout(this.keepRatio, 250)
			},
			keepRatio() {
				if (!this.$el)
					return

				let width = window.innerWidth
				let height = window.innerHeight
				
				// Make sure the app is always contained in a 16/9 centered frame
				let ratio = (width / height)

				if (ratio > 16/9) {
					// Width is greater than height
					this.$el.style.width = (height * (16 / 9)) + 'px' 
					this.$el.style.height = height + 'px' 
				} else {
					// Height is greater than width
					this.$el.style.width = width + 'px' 
					this.$el.style.height = (width / (16 / 9)) + 'px' 
				}

				this.ready = true;
			}
		}
	}
</script>

<style lang="scss">
html {
	font-size: 75%;
}

@screen xxl {
	html {
		font-size: 100%;
	}
}

body {
	display: flex;
	align-items: center;
	justify-content: center;
}

#app {// todo
	@apply text-black text-center;
	font-family: AvenirNext, Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
